import React, { Component } from 'react';

import ContentContainer from 'common/containers/ContentContainer';
import Link from 'common/Link';
import NavLogo from 'common/NavLogo';
import devURL from 'common/util/devURL';

import 'css/components/jobs/_JobsNav.scss';

export default class JobsNav extends Component {
  render() {
    return (
      <ContentContainer outerClassName="jobsNav" innerClassName="innerContainer">
        <div className="left">
          <NavLogo style="dark" />
          <Link to="/">
            <div className="heading">Jobs</div>
          </Link>
        </div>
        <a className="cannyLink" href={devURL('https://canny.io')} rel="noopener" target="_blank">
          Visit Canny.io
        </a>
      </ContentContainer>
    );
  }
}
